<template>
  <div class="main-content">
    <div class="main-title">数据备份列表</div>
    <div class="main-btn">
      <span class="btn-add" @click="startBak">启动备份任务</span>
    </div>
    <table>
      <tr>
        <th width="100">ID</th>
        <th class="td-left">备份名称</th>
        <th class="td-left" width="200">备份开始时间</th>
        <th class="td-left" width="200">备份完成时间</th>
        <th width="100">状态</th>
        <th width="120">操作</th>
      </tr>
      <template v-for="(item) in list">
        <tr class="row" :key="item.id" @click="rowSelect(item.id)">
          <td class="td-center">{{item.id}}</td>
          <td>{{item.title}}</td>
          <td>{{item.created_at}}</td>
          <td>{{item.updated_at}}</td>
          <td class="td-center" :class="stateStyleKV[item.state]">{{stateNameKV[item.state]}}</td>
          <td class="td-center">
            <div v-if="item.state == 3" class="op-row download" @click="downloadBak(item.download_url)">下载</div>
            <div v-if="item.state == 3" class="op-row download" @click="deleteBak(item.id)">删除</div>
          </td>
        </tr>
      </template>
    </table>
    <div class="paging-box">
      <paging :current-page="page" :total="total" :page-size="9" @currentChange="pageChange"/>
    </div>
  </div>
</template>

<script>
import {getBakList,startBak,startDel} from "@/request/api";
import paging from "@/components/paging";
import {Warning} from "@/plugins/warning";

export default {
  name: "sys_bak",
  components:{
    paging
  },
  data() {
    return {
      list:[],
      page: 0,
      total: 0,
      totalPage: 0,
      selectRow: 0,
      stateNameKV:{
        1:"准备中",
        2:"备份中",
        3:"备份完毕",
        9:"备份失败"
      },
      stateStyleKV:{
        1:"black",
        2:"gold",
        3:"green",
        9:"red"
      }
    }
  },
  computed: {

  },
  created() {
    this.getList();
  },
  mounted() {

  },
  methods: {
    getList(e){
      const curPage = e || this.page
      const requestData = {
        page: curPage,
      };
      getBakList(requestData).then((res)=>{
        this.list = res.data.list;
        this.total = res.data.paging.recordCount
        this.totalPage = res.data.paging.pageCount
        this.page = curPage
      })
    },
    pageChange(e){
      this.getList(e)
    },
    rowSelect(sel){
      if(sel == this.selectRow){
        this.selectRow = 0;
      }else{
        this.selectRow = sel;
      }
    },
    downloadBak(sel){
      window.open(sel,"_blank");
    },
    deleteBak(id){
      this.$confirm("确定删除开始备份?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const requestData = {"id":id};
        startDel(requestData).then(()=>{
          Warning.success('删除完毕');
          this.getList(0);
        })
      })
    },
    startBak(){
      this.$confirm("确定是否开始备份?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const requestData = {};
        startBak(requestData).then(()=>{
          Warning.success('备份已经开始，请等待备份完成后下载备份文件');
          this.getList(0);
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content{
  width: 100%;
  border-radius: 30px;
  background: #fff;
  box-shadow: 0 15px 30px  rgba(0, 0, 0, .1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-bottom: 45px;
  .main-title{
    font-size: 24px;
    font-weight: 600;
    color: #141414;
    margin-left: 30px;
    margin-top: 30px;
  }
  .main-btn{
    font-size: 24px;
    font-weight: 600;
    color: #141414;
    margin-right: 30px;
    margin-top: 30px;
    .btn-add{
      display: block;
      width: 200px;
      line-height: 48px;
      font-size: 21px;
      font-weight: 300;
      text-align: center;
      cursor: pointer;
      color: #fff;
      border-radius: 25px;
      background-color: #ba0704;
    }
  }
  & > table{
    width: 100%;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
    border-collapse:separate;
    border-spacing:0px 30px;
    & > tr{
      & > th{
        font-size: 18px;
        font-family: Jost-Medium, Jost;
        font-weight: 500;
        color: #000;
        padding-left: 15px;
        padding-right: 15px;
      }
    }
    .td-left{
      text-align: left;
    }
    .td-center{
      text-align: center;
    }
    .row{
      background: #f8f6f0;
      border-radius: 15px;
      box-shadow: 0 0 0 5px #f8f6f0;
      height: 50px;
      font-size: 17px;
      font-family: PingFang HK-Regular, PingFang HK;
      font-weight: 400;
      color: #2E2E2E;
      position: relative;
      td{
        vertical-align:middle;
        padding-left: 15px;
        padding-right: 15px;
      }
      .download{
        cursor: pointer;
        float: left;
        margin-left: 15px;
      }
      .black{
        color: #000;
      }
      .red{
        color: red;
      }
      .green{
        color: green;
      }
    }
  }

  .paging-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    //padding: 0 130px;
  }
}
</style>
